module.exports = __webpack_public_path__ + "static/media/seller-guide-center-image.b03ef4ad.png";